// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    INNOVATION_BY_DESIGN_PAGE_LOADING() {
      return {
        isLoading: true,
        innovationByDesignPage: action.innovationByDesignPage
      };
    },
    INNOVATION_BY_DESIGN_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.homepage
      };
    },
    INNOVATION_BY_DESIGN_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.innovationByDesignPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
